import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=571566ac&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=571566ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571566ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571566ac')) {
      api.createRecord('571566ac', component.options)
    } else {
      api.reload('571566ac', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=571566ac&scoped=true&", function () {
      api.rerender('571566ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ze5sY6jLHenO/JS/comp/PopupBox.vue"
export default component.exports